'use strict';

document.addEventListener('DOMContentLoaded', function () {

  // ==========================================
  // モーダルを開く共通処理
  // ==========================================
  function openModal(btn) {
    var target = btn.getAttribute('data-target');
    var targetElement = document.querySelector("." + target);
    if (targetElement) {
      targetElement.style.display = 'block';
      var closeBtn = document.querySelector('.js-close-button');
      if (closeBtn) closeBtn.style.display = 'block';
      var overlay = document.querySelector('.js-modal-overlay');
      if (overlay) overlay.style.display = 'block';
      document.body.classList.add('no-move');
    }
  }

  // ==========================================
  // 1. MutationObserverの設定（アプリ生成ボタンを監視）
  // ==========================================
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          // 追加されたのがHTML要素(Element)であるかチェック
          if (node.nodeType === 1) {
            // 追加された要素自身、またはその中からボタンを探す
            const buttons = node.matches('.js-open-button') 
                            ? [node] 
                            : node.querySelectorAll('.js-open-button');
            
            if (buttons && buttons.length > 0) {
              buttons.forEach(function(btn) {
                // 【最重要】送信ボタン化を防ぐ魔法を、生成された瞬間に付与！
                btn.setAttribute('type', 'button');
                
                // 処理の重複登録を防ぐための工夫
                if (!btn.dataset.isBinded) {
                  btn.dataset.isBinded = 'true';
                  btn.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    openModal(btn);
                  });
                }
              });
            }
          }
        });
      }
    });
  });

  // 監視スタート（bodyの中身が変更・追加されるのをずっと見張る）
  observer.observe(document.body, { childList: true, subtree: true });

  // ==========================================
  // 2. 最初からHTMLに存在するボタン用の処理
  // ==========================================
  const existingButtons = document.querySelectorAll('.js-open-button');
  existingButtons.forEach(function(btn) {
    btn.setAttribute('type', 'button');
    if (!btn.dataset.isBinded) {
      btn.dataset.isBinded = 'true';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openModal(btn);
      });
    }
  });

  // ==========================================
  // 3. モーダルを閉じる処理
  // ==========================================
  document.addEventListener('click', function(e) {
    // 閉じるボタン、または黒い背景(オーバーレイ)が押されたら閉じる
    const closeTrigger = e.target.closest('.js-close-button, .js-modal-overlay');
    if (closeTrigger) {
      e.preventDefault();
      e.stopPropagation();
      
      const realCloseBtn = document.querySelector('.js-close-button');
      if(realCloseBtn) realCloseBtn.style.display = 'none';
      
      var modalInElements = document.querySelectorAll('.mh-modal-in');
      for (var i = 0; i < modalInElements.length; i++) {
        modalInElements[i].style.display = 'none';
      }
      var overlay = document.querySelector('.js-modal-overlay');
      if (overlay) overlay.style.display = 'none';
      
      document.body.classList.remove('no-move');
    }
  });

});